<template>
  <b-modal v-bind="$attrs">
    <template #modal-header="{ close }">
      <h5>{{ $attrs.title }}</h5>
    </template>
    <slot></slot>
  </b-modal>
</template>

<script>
export default {
  name: 'export-modal',
}
</script>

<style lang="scss" scoped>
::v-deep{
  .modal-content {
    .modal-header {
      border-bottom: 0;
      padding-bottom: 0;
    }
    .modal-footer {
      border-top: 0;
      display: flex;
      justify-content: space-between;
    }
  }
  .btn {
    border-radius: 8px;
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: center;

  }
  .btn-outline-dark {
    color: #454646;
    &:hover {
      color: white;
    }
  }
}
</style>